import {
  LOCATION_TYPES,
  LOCATION_TYPE_TAGS,
} from "@circle-react/components/Events/helpers/constants";
import { useSmOrMdScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

export const EventLocation = ({ type }: any) => {
  const isSmallScreen = useSmOrMdScreenMediaQuery();

  return (
    <div className="flex items-center gap-x-2">
      {!isSmallScreen && (
        <Icon
          type={
            type === LOCATION_TYPES.IN_PERSON || type === LOCATION_TYPES.TBD
              ? "16-location"
              : "16-camera"
          }
          size={16}
          className="text-default !w-4"
        />
      )}
      <Typography.LabelXs>{LOCATION_TYPE_TAGS[type]}</Typography.LabelXs>
    </div>
  );
};
